import {i18n} from '@/plugins/i18n';
import {walletStatusStr, walletStatusVariant} from "@/constants/walletStatus";

export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'wallet_title',
        title: i18n.t('wallets.label.wallet_title'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'total_amount',
        title: i18n.t('label.total_balance'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'available_amount',
        title: i18n.t('label.available_balance'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'blocked_amount',
        title: i18n.t('label.blocked_amount'),
        sortable: false,
        textAlign: 'center',
        template: row => {
            return `<span dir="ltr">${row.blocked_amount} (+${row.blocked_transaction_amount})</span>`;
        },
    },
    {
        field: 'user',
        title: i18n.t('label.user'),
        sortable: false,
        template: row => {
            return `<a href="/users/${row.user.id}/details" target="_blank">${row.user.name}</a>`;
        },
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        sortable: false,
        template: row => {
            return `<span class="badge badge-${walletStatusVariant(row.status)}">${walletStatusStr.get(row.status)}</span>`;
        },
        textAlign: 'center',
    },
]
